import { z } from 'zod';
// ============================================================
// Guestbook Schemas
// ============================================================
// Note: profanity filter validation is applied at the API layer (middleware),
// not in the shared schema, to avoid server-only dependencies in shared package.
export const SubmitGuestbookEntrySchema = z.object({
    name: z
        .string()
        .min(1, '이름을 입력해주세요')
        .max(100, '이름은 100자를 초과할 수 없습니다'),
    message: z
        .string()
        .min(1, '메시지를 입력해주세요')
        .max(500, '메시지는 500자를 초과할 수 없습니다'),
    isPrivate: z.boolean().default(false),
    password: z
        .string()
        .min(1, '비밀번호를 입력해주세요')
        .max(20, '비밀번호는 20자를 초과할 수 없습니다'),
});
export const GuestbookEntryPublicSchema = z.object({
    id: z.string(),
    name: z.string(),
    message: z.string(),
    createdAt: z.string(),
});
export const GuestbookEntryOwnerSchema = GuestbookEntryPublicSchema.extend({
    isPrivate: z.boolean(),
    isHidden: z.boolean(),
});
export const GuestbookListPublicSchema = z.object({
    entries: z.array(GuestbookEntryPublicSchema),
    nextCursor: z.string().nullable(),
    total: z.number().int().min(0),
});
export const GuestbookListOwnerSchema = z.object({
    entries: z.array(GuestbookEntryOwnerSchema),
    total: z.number().int().min(0),
    hiddenCount: z.number().int().min(0),
    privateCount: z.number().int().min(0),
});
export const PatchGuestbookEntrySchema = z.object({
    isHidden: z.boolean(),
});
export const DeleteGuestbookByPasswordSchema = z.object({
    password: z.string().min(1, '비밀번호를 입력해주세요'),
});
//# sourceMappingURL=guestbook.js.map